import React, { useState, useEffect } from 'react';
import './AddReferral.css';

const AddReferral = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    date: '',
    company: '',
    phone: '',
    comments: '', // Now included
    referralName: '',
    referenceName: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    date: '',
    company: '',
    phone: '',
    referralName: '',
    referenceName: '',
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profileResponse = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/my-profile`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!profileResponse.ok) throw new Error('Failed to fetch profile');

        const profileData = await profileResponse.json();
        const fullName = profileData.firstName && profileData.lastName
          ? `${profileData.firstName} ${profileData.lastName}`
          : profileData.firstName || profileData.lastName || 'Unknown User';

        setFormData((prevState) => ({
          ...prevState,
          name: fullName,
        }));
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    const fetchUsers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/user`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setUsers(data);
        } else {
          console.error('No users found or invalid data format');
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
    fetchUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validatePhoneNumber = (phone) => /^[0-9]{10}$/.test(phone);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.date) newErrors.date = 'Date is required';
    if (!formData.company) newErrors.company = 'Company name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    else if (!validatePhoneNumber(formData.phone)) newErrors.phone = 'Invalid phone number';
    if (!formData.referenceName) newErrors.referenceName = 'You must select a user';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validateForm()) {
      alert('Please fill out all required fields');
      return;
    }
  
    try {
      const apiUrl = `${process.env.REACT_APP_SERVER_IP}/api/admin/referral`;
      const token = localStorage.getItem('token');
  
      if (!token) {
        alert('No authorization token found');
        return;
      }
  
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name: formData.name,
          date: formData.date,
          company: formData.company,
          phone: formData.phone,
          referralName: formData.referralName,
          referenceName: formData.referenceName,
          comments: formData.comments, // Ensure comments are included
        }),
      });
  
      const result = await response.json();
  
      if (!response.ok) {
        alert(`Failed to add referral: ${result.message || 'Unknown error'}`);
        return;
      }
  
      alert('Referral added successfully!');
      setFormData({
        name: formData.name,
        date: '',
        company: '',
        phone: '',
        comments: '', // Clear comments after submission
        referralName: '',
        referenceName: '',
      });
      setErrors({});
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while adding the referral');
    }
  };
  

  return (
    <div className="contain">
      <main className="main-content">
        <div className="form-containerReferral">
          <h2 className='name'>Add Referral</h2>
          <form id="userForm" onSubmit={handleSubmit}>
            <div className="form-group1">
              <input
                type="date"
                id="date"
                name="date"
                placeholder="Date"
                value={formData.date}
                onChange={handleChange}
                required
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div className="form-group1">
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                value={formData.name}
                style={{ backgroundColor: '#e9ebf7' }}
                readOnly
                required
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>

            <div>
              <select
                id="referenceName"
                name="referenceName"
                value={formData.referenceName}
                onChange={handleChange}
                className="form-group11"
                required
              >
                <option value="">Select User</option>
                {loading ? (
                  <option>Loading...</option>
                ) : (
                  users.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : 'Unknown'}
                    </option>
                  ))
                )}
              </select>
              {errors.referenceName && <span className="error">{errors.referenceName}</span>}
            </div>

            <div className="form-group1">
              <input
                type="text"
                id="referralName"
                name="referralName"
                placeholder="Referral Name"
                value={formData.referralName}
                onChange={handleChange}
                required
              />
              {errors.referralName && <span className="error">{errors.referralName}</span>}
            </div>

            <div className="form-group1">
              <input
                type="text"
                id="company"
                name="company"
                placeholder="Referral Company Name / Referral Brand Name"
                value={formData.company}
                onChange={handleChange}
                required
              />
              {errors.company && <span className="error">{errors.company}</span>}
            </div>

            <div className="form-group1">
              <input
                type="text"
                id="phone"
                name="phone"
                placeholder="Contact Number"
                value={formData.phone}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  if (value.length <= 10) {
                    setFormData((prevData) => ({
                      ...prevData,
                      phone: value,
                    }));
                  }
                }}
                maxLength="10"
                pattern="\d{10}"
                title="Please enter exactly 10 digits"
                required
              />
              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>

            <div className="form-group1">
              <input
                type="text"
                id="comments"
                name="comments"
                placeholder="Comments (Optional)"
                value={formData.comments}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="update-detailsAdd">
              Add Referral
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddReferral;
